import React from 'react';
import { Typography } from '@mui/material';
import { format, startOfToday } from 'date-fns';
import { WarningDialog } from 'src/components/general/WarningDialog';
import { getSubscriptionTermLabel, getSubscriptionTermLengthInMonths } from 'src/constants/subscriptionTerm';
import { TERM_DATE_FORMAT, getCommitmentEndDate, getMonthsBetween, getRenewalDate, pluralizeMonths } from '../SubscriptionTerm';
import useStyles from './styles';
const formatRenewalDate = date => date ? format(date, TERM_DATE_FORMAT) : '';
const parseDateOnly = value => value ? new Date("".concat(value, "T00:00:00")) : null;
const getAgreementWording = (previousTerm, startDate, storedCommitmentEndDate) => {
  var _parseDateOnly;
  const commitmentEndDate = (_parseDateOnly = parseDateOnly(storedCommitmentEndDate)) !== null && _parseDateOnly !== void 0 ? _parseDateOnly : getCommitmentEndDate(startDate, previousTerm);
  if (!commitmentEndDate) return null;
  const length = getSubscriptionTermLengthInMonths(previousTerm);
  const label = getSubscriptionTermLabel(previousTerm).toLowerCase();
  return "This account is on a ".concat(length, "-month ").concat(label, " agreement ending ").concat(format(commitmentEndDate, 'MMM dd, yyyy'), ".");
};
const getReleasedMonths = (previousTerm, previousStartDate, term, startDate) => {
  const today = startOfToday();
  return getMonthsBetween(today, getCommitmentEndDate(previousStartDate, previousTerm)) - getMonthsBetween(today, getCommitmentEndDate(startDate, term));
};
export const TermChangeConfirmation = _ref => {
  var _parseDateOnly2;
  let isOpen = _ref.isOpen,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    accountName = _ref.accountName,
    previousTerm = _ref.previousTerm,
    previousStartDate = _ref.previousStartDate,
    previousRenewalDate = _ref.previousRenewalDate,
    previousCommitmentEndDate = _ref.previousCommitmentEndDate,
    term = _ref.term,
    startDate = _ref.startDate;
  const classes = useStyles();
  const previousRenewal = formatRenewalDate((_parseDateOnly2 = parseDateOnly(previousRenewalDate)) !== null && _parseDateOnly2 !== void 0 ? _parseDateOnly2 : getRenewalDate(previousStartDate, previousTerm));
  const nextRenewal = formatRenewalDate(getRenewalDate(startDate, term));
  const releasedMonths = getReleasedMonths(previousTerm, previousStartDate, term, startDate);
  const agreementWording = getAgreementWording(previousTerm, previousStartDate, previousCommitmentEndDate);
  return /*#__PURE__*/React.createElement(WarningDialog, {
    isOpen: isOpen,
    title: "Confirm Term Change",
    subtitle: accountName,
    onCancel: onCancel,
    onConfirm: onConfirm
  }, !!agreementWording && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, agreementWording), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Term changes from", ' ', /*#__PURE__*/React.createElement("span", {
    className: classes.emphasis
  }, "".concat(getSubscriptionTermLabel(previousTerm), " to ").concat(getSubscriptionTermLabel(term))), releasedMonths > 0 ? ", estimated revenue lost of ".concat(pluralizeMonths(releasedMonths), ".") : '.'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Renewal ".concat(previousRenewal, " \u2192 ").concat(nextRenewal, ".")));
};